import { render, staticRenderFns } from "./Annotate.vue?vue&type=template&id=372a8a93&scoped=true"
import script from "./Annotate.vue?vue&type=script&lang=js"
export * from "./Annotate.vue?vue&type=script&lang=js"
import style0 from "./Annotate.vue?vue&type=style&index=0&id=372a8a93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372a8a93",
  null
  
)

export default component.exports